import React, { useState, useRef } from 'react'
import classnames from 'classnames'
import dayjs from 'dayjs'
import plural from 'plural-ru'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import FeaturesList from './FeaturesList'
import SubscriptionManagementSelect from './SubscriptionManagementSelect'
import Button from './Button'
import Spinner from './Spinner'
import { profileSelector } from '../reducers/profile'
import providerImage from '../utils/providerImage'
import products_new from '../constants/ProductsNew'
import { patchSubscription } from '../actions/api'
import { getDiscountsSelector } from '../reducers/discounts'
import { setDiscounts } from '../actions/utils'
import find from 'lodash/find'
import get from 'lodash/get'

import '../styles/subscription.scss'

function Subscription({
  profile,
  id,
  kind,
  lastPaymentProduct,
  type,
  product,
  active,
  promoCode,
  expiresAt,
  cancelledAt,
  delayedDurationDays,
  withSelect,
  patchSubscription,
  currency,
  priceCents,
  nextPriceCents,
  extraTipCents,
  introductoryPriceCents,
  index
}) {
  const [loading, setLoading] = useState(false)
  const yourSubscriptionEl = useRef(null)
  const [isSubscriptionManagement, setSubscriptionManagement] = useState(false)
  const [differentProducts, setDifferentProducts] = useState(false)

  const formattedExpiresAt = dayjs.unix(expiresAt).format('DD.MM.YYYY')
  const lastPaymentProductDetails = find(products_new, { product: lastPaymentProduct })
  const oldPrice = (priceCents || 0) / 100
  const effectivePrice = ((introductoryPriceCents ? introductoryPriceCents : priceCents) || 0) / 100
  const effectivePriceWithCurrency = currency === 'RUB' ? `${effectivePrice} ₽` : `${currency} ${effectivePrice}`
  const isPaidTrialOrIntroductorySubscription = Boolean(introductoryPriceCents)
  const isLifetime = lastPaymentProductDetails?.product.includes('lifetime')
  const priceWithoutTipCents = (priceCents || 0) - extraTipCents
  const nextPriceWithoutTipCents = (nextPriceCents || 0) - extraTipCents
  const currencySign = currency === 'RUB' ? '₽' : currency
  return (
    <div
      className={classnames('account-block', {
        'account-block--promocode': Boolean(promoCode) || isLifetime
      })}>
      {/* Рендерим только один раз */}
      {active && !index && (
        <div className="account-title" ref={yourSubscriptionEl}>
          Ваша подписка
        </div>
      )}

      <div className="account-wrapper account-wrapper--management account-wrapper--kids" id={type}>
        {/*{id}*/}
        {/* ВЕРХНИЙ БЕЙДЖ*/}
        {kind && kind !== 'promo_subscription' && renderTopBadge()}
        {/**/}
        {/* ЛОГО */}
        {(isLifetime || expiresAt) && (
          <div className="account-subscription__header account-subscription__header--inactive-sub">
            {renderHeaderLogo()}
            {promoCode && (
              <div className="account-subscription__promocode">
                <span>
                  Промокод{' '}
                  {delayedDurationDays &&
                    delayedDurationDays < 36500 &&
                    `на ${delayedDurationDays} ${plural(delayedDurationDays, 'день', 'дня', 'дней')}`}
                  {delayedDurationDays && delayedDurationDays >= 36500 && `на вечную подписку`}
                </span>
                <br />
                <strong>{promoCode}</strong>
              </div>
            )}
            {isLifetime && (
              <div className="account-subscription__expire">
                <span>Подписка</span>
                <br />
                <strong>Навсегда</strong>
              </div>
            )}
            {/* ПРАВЫЙ ТЕКСТ */}
            {!isLifetime && renderRightText()}
          </div>
        )}
        {/**/}
        {kind !== 'promo_subscription' && renderActiveSubscriptionPriceInfo()}
        {/**/}
        {/* Возобновить подписку */}
        {kind === 'web_subscription' && Boolean(cancelledAt) && (
          <Button onClick={handleResumeCancelledClick} disabled={loading} isSubscription>
            {loading ? <Spinner /> : 'Возобновить подписку'}
          </Button>
        )}
        {/**/}
        {/* Управление подпиской */}
        {kind === 'web_subscription' && !isLifetime && !Boolean(cancelledAt) && !isSubscriptionManagement && (
          <>
            {renderAttentionText()}
            <Button onClick={handleSubscriptionManagementClick} isSubscription>
              Управление подпиской
            </Button>
          </>
        )}
        {/**/}
        {/* ПОЯВЛЯЕТСЯ ЕСЛИ НАЖАТЬ НА Управление подпиской */}
        {(withSelect || isSubscriptionManagement) && (
          <SubscriptionManagementSelect
            id={id}
            type={type}
            activeProduct={product}
            withPay={differentProducts}
            onProductChange={handleProductChange}
            setSubscriptionManagement={setSubscriptionManagement}
          />
        )}
        {/**/}
        {/* КНОПКА ОТМЕНИТЬ ПОДПИСКУ*/}
        {isSubscriptionManagement && renderCancelSubscription()}
        {/**/}
        {/**/}
        {/* Если подписка есть и она общая ВЫВОДИТ Особенности*/}
        {product && product === 'pack_yearly' && <FeaturesList />}
        {/**/}
        {/**/}
        {kind === 'apple_subscription' && renderAppleSubscription()}
        {/**/}
        {/**/}
        {kind === 'google_subscription' && renderGoogleSubscription()}
        {/**/}
        {/**/}
        {kind === 'google_subscription' && currency === 'RUB' && (
          <div className="account-subscription__description">
            Цена указана для российского магазина приложений Google Play. Актуальную цену для вашей страны
            вы&nbsp;можете узнать в&nbsp;приложении.
          </div>
        )}

        {kind === 'apple_subscription' && currency === 'RUB' && (
          <div className="account-subscription__description">
            Цена указана для российского магазина приложений App Store. Актуальную цену для вашей страны вы&nbsp;можете
            узнать в&nbsp;приложении.
          </div>
        )}
      </div>
    </div>
  )

  function renderTopBadge() {
    return (
      <div
        className={classnames('account-subscription__badge', {
          'account-subscription__badge--inactive': active && Boolean(cancelledAt)
        })}>
        {active ? (Boolean(cancelledAt) ? 'Подписка без продления' : 'Ура, все работает!') : 'Еще не активна'}
      </div>
    )
  }

  function renderHeaderLogo() {
    return (
      <div
        className={classnames(
          'account-subscription__logo',
          { 'account-subscription__logo--arzamas': kind === 'promo_subscription' },
          { 'account-subscription__logo--web': kind === 'web_subscription' },
          { 'account-subscription__logo--multiple': type === 'pack' }
        )}>
        {type === 'pack' && (
          <>
            <img src={providerImage(kind)} alt="Радио Arzamas" />
            <div className="account-subscription__wrap">
              <svg width="33" height="33" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M15.881 0c.338 0 .619.28.619.619v14.643c0 .685-.553 1.238-1.238 1.238H.62A.623.623 0 010 15.881c0-.338.28-.619.627-.619 8.027 0 14.635-6.608 14.635-14.635 0-.346.281-.627.62-.627zm1.857 16.5H32.38c.338 0 .619.28.619.619a.63.63 0 01-.627.619c-8.027 0-14.635 6.608-14.635 14.635 0 .346-.281.627-.62.627a.623.623 0 01-.618-.619V17.738c0-.685.553-1.238 1.238-1.238z"
                  fill="#000"
                />
              </svg>
              Гусьгусь
            </div>
          </>
        )}
        {type === 'radio' && <img src={providerImage(kind)} alt="Радио Arzamas" />}
        {type === 'kids' && (
          <>
            <svg width="33" height="33" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15.881 0c.338 0 .619.28.619.619v14.643c0 .685-.553 1.238-1.238 1.238H.62A.623.623 0 010 15.881c0-.338.28-.619.627-.619 8.027 0 14.635-6.608 14.635-14.635 0-.346.281-.627.62-.627zm1.857 16.5H32.38c.338 0 .619.28.619.619a.63.63 0 01-.627.619c-8.027 0-14.635 6.608-14.635 14.635 0 .346-.281.627-.62.627a.623.623 0 01-.618-.619V17.738c0-.685.553-1.238 1.238-1.238z"
                fill="#000"
              />
            </svg>
            Гусьгусь
          </>
        )}
      </div>
    )
  }

  function renderActiveSubscriptionPriceInfo() {
    if (!Boolean(cancelledAt) && lastPaymentProductDetails) {
      const periodLabel = isPaidTrialOrIntroductorySubscription ? null : get(lastPaymentProductDetails, 'title')
      const extraTipsLabel = extraTipCents ? `в том числе доплата ${extraTipCents / 100} ${currencySign}` : null
      const priceSubtitle = [periodLabel, extraTipsLabel].filter(Boolean).join(', ')
      return (
        <div className="account-subscription__info">
          <div className="account-subscription__info-content">
            <div
              className={classnames('account-subscription__price', {
                'account-subscription__price--trial': isPaidTrialOrIntroductorySubscription
              })}>
              {!isPaidTrialOrIntroductorySubscription && oldPrice !== effectivePrice && (
                <div className="account-subscription__old-price">{oldPrice}</div>
              )}
              {effectivePriceWithCurrency}
            </div>
            {Boolean(priceSubtitle) && <div className="account-subscription__period">{priceSubtitle}</div>}
          </div>
        </div>
      )
    }
    return null
  }

  function renderAttentionText() {
    return (
      <>
        {/*Следущее списание будет по тому же плану, но по другой цене*/}
        {product === lastPaymentProduct && (Boolean(introductoryPriceCents) || priceCents !== nextPriceCents) && (
          <div className="account-subscription__attention">
            <strong>Внимание!</strong>{' '}
            {extraTipCents ? 'Следующее списание будет по цене ' : 'Следующее списание будет по стандарной цене '}
            <strong>
              {(nextPriceWithoutTipCents || 0) / 100} {currencySign}
              {Boolean(extraTipCents) &&
                ` + ${extraTipCents / 100} ${currencySign} = ${nextPriceCents / 100} ${currencySign}`}
            </strong>
          </div>
        )}
        {/*Следущее списание будет по другому плану*/}
        {product !== lastPaymentProduct && (
          <div className="account-subscription__attention">
            <strong>Внимание!</strong> Следующее списание будет по&nbsp;
            {product ? getAttentionText() : 'тарифу:'}{' '}
            <strong>
              {(nextPriceWithoutTipCents || 0) / 100} {currencySign}
              {Boolean(extraTipCents) &&
                ` + ${extraTipCents / 100} ${currencySign} = ${nextPriceCents / 100} ${currencySign}`}
            </strong>
          </div>
        )}
      </>
    )
  }

  function getAttentionText() {
    const lastPart = ' тарифу:'

    if (product.includes('lifetime')) {
      return 'тарифу Навсегда: '
    }

    if (product.includes('triennial')) {
      return 'трехгодовому' + lastPart
    }

    if (product.includes('yearly')) {
      return 'годовому' + lastPart
    }

    return 'месячному' + lastPart
  }

  function renderCancelSubscription() {
    return (
      <>
        {differentProducts && <div className="account-subscription__hr" />}
        <div className="account-subscription__description">
          {/* Чтобы изменить платежные реквизиты, отмените текущую подписку и&nbsp;оформите другую с&nbsp;новыми данными.
              Обещаем, все получится!
              <br />
              <br /> */}
          Если вы&nbsp;отмените подписку сейчас, она продолжит действовать до&nbsp;{formattedExpiresAt}
          {Boolean(extraTipCents) && (
            <>
              <br />
              <br />
              С каждым платежом вы дополнительно помогаете Arzamas на {extraTipCents / 100} {currencySign}, спасибо!
              <br />
              Скоро мы добавим возможность изменять эту сумму из личного кабинета, а пока можно написать{' '}
              <nobr>
                нам на <a href="mailto:radio@arzamas.academy">radio@arzamas.academy</a>
              </nobr>
              , если захотите это сделать.
            </>
          )}
        </div>
        <Button onClick={handleCancelClick} disabled={loading} isSubscription>
          {loading ? <Spinner /> : 'Отменить подписку'}
        </Button>
      </>
    )
  }

  function renderAppleSubscription() {
    if (!Boolean(cancelledAt)) {
      return (
        <>
          <div className="account-subscription__description">
            По&nbsp;правилам компании Apple мы&nbsp;не&nbsp;можем управлять вашей подпиской. Для этого вам нужно зайти
            в&nbsp;настройки своей учетной записи App Store и&nbsp;самостоятельно отменить там подписку или изменить
            платежные реквизиты.
            <br />
            <br />
            Если вы&nbsp;отмените подписку сейчас, она продолжит действовать до&nbsp;{formattedExpiresAt}
          </div>
          <Button isSubscription component="a" href="https://support.apple.com/ru-ru/HT211011" target="_blank">
            Управление подпиской
          </Button>
        </>
      )
    }

    return null
  }

  function renderGoogleSubscription() {
    if (!Boolean(cancelledAt)) {
      return (
        <>
          <div className="account-subscription__description">
            По&nbsp;правилам компании Google мы&nbsp;не&nbsp;можем управлять вашей подпиской. Для этого вам нужно зайти
            в&nbsp;настройки своей учетной записи Google Play и&nbsp;самостоятельно отменить там подписку или изменить
            платежные реквизиты.
            <br />
            <br />
            Если вы&nbsp;отмените подписку сейчас, она продолжит действовать до&nbsp;{formattedExpiresAt}
          </div>
          <Button
            isSubscription
            component="a"
            href="https://play.google.com/store/account/subscriptions"
            target="_blank">
            Управление подпиской
          </Button>
        </>
      )
    }

    return null
  }

  function renderRightText() {
    return (
      <>
        {Boolean(delayedDurationDays) && profile.subscriptions.length && type !== 'pack' ? (
          <div className="account-subscription__expire">
            <span>
              Заработает после
              <br />
              окончания подписки
            </span>
          </div>
        ) : (
          <div className="account-subscription__expire">
            <span>
              {Boolean(cancelledAt) || kind === 'promo_subscription' ? 'Подписка заканчивается' : 'Следующее списание'}
            </span>
            <br />
            <strong>{formattedExpiresAt}</strong>
          </div>
        )}
      </>
    )
  }

  async function handleResumeCancelledClick() {
    setLoading(true)
    await patchSubscription(id, { resume_cancelled: true })
    setLoading(false)
  }

  function handleSubscriptionManagementClick() {
    setSubscriptionManagement(true)
  }

  function handleProductChange(selectedProduct) {
    setDifferentProducts(product !== selectedProduct)
    // setSelectedProduct(selectedProduct)
  }

  async function handleCancelClick() {
    setLoading(true)
    await patchSubscription(id, { cancel: true })
    setLoading(false)
    setSubscriptionManagement(false)
  }
}

const mapStateToProps = createStructuredSelector({
  profile: profileSelector,
  discounts: getDiscountsSelector
})

export default connect(mapStateToProps, { patchSubscription, setDiscounts })(Subscription)
